import PropTypes from "prop-types";
import { useFormContext, Controller } from "react-hook-form";
import { Checkbox } from "@shopify/polaris";

RHFCheckbox.propTypes = {
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.string,
};

export default function RHFCheckbox({ name, disabled = false, label, ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Checkbox label={label} checked={field.value} onChange={field.onChange} disabled={disabled} {...other} />
      )}
    />
  );
}
